module.exports = __webpack_public_path__ + "img/slide_1.60c52faf.png";